import { render, staticRenderFns } from "./RegistrationFormDetailed.vue?vue&type=template&id=3058b170"
import script from "./RegistrationFormDetailed.vue?vue&type=script&lang=js"
export * from "./RegistrationFormDetailed.vue?vue&type=script&lang=js"
import style0 from "./RegistrationFormDetailed.vue?vue&type=style&index=0&id=3058b170&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports